import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    HostListener,
    Input,
} from '@angular/core';
import { MainTableComponent } from '../main-table.component';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { of as observableOf } from 'rxjs';
import { TableResponseQuery } from '../../../core/models/';

@Component({
    selector: 'inner-table',
    templateUrl: './inner-table.component.html',
    styleUrls: ['../main-table.component.scss'],
})
export class InnerTableTableComponent extends MainTableComponent {
    @Input()
    set innerTable(flag: boolean) {
        if (flag) {
            this.screenHeight = 'calc(100% - 57px)';
        }
    }

    @Input() idsList: Array<number>;

    loadPage() {
        this.loadSubscription = this.paginator.page
            .pipe(
                startWith({}),
                switchMap(() => {
                    this.isLoadingResults = true;
                    return this.dataService.fetchInnerData(
                        this.pageSize,
                        this.paginator.pageIndex * this.pageSize,
                        this.sortBy,
                        this.filterValue,
                        this.selFilterValue,
                        this.idsList
                    );
                }),
                map((data: TableResponseQuery) => {
                    this.itemsLength = data.total_count;
                    this.isLoadingResults = false;
                    return data.items;
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    return observableOf([]);
                })
            )
            .subscribe((data: any[]) => {
                this.data = data;
            });
    }
}
